import { pxToRem, pxTovW } from '@geneo2-web/shared-ui';
import { Skeleton, TableBody, TableCell, TableRow } from '@mui/material';

interface IProps {
  rows: number;
  column: number;
}
export const TableShimmerQP = (props: IProps) => {
  return (
    <TableBody>
      {Array.from({ length: props.rows }).map((data, rowIndex) => (
        <TableRow key={rowIndex}>
          {Array.from({ length: props.column }).map((data, columnIndex) => (
            <TableCell key={columnIndex}>
              <Skeleton
                variant="text"
                sx={{
                  width: { xs: pxToRem(115), md: '100%' },
                  height: { xs: pxToRem(25), md: pxTovW(40) },
                }}
              />
            </TableCell>
          ))}
        </TableRow>
      ))}
    </TableBody>
  );
};
